// COHESION CONSTANTS
export const WRITE_KEY = process.env.environment === 'production' ? 'wk_1NT297N9odoW0CqWvYg7phqu6Jl' : 'wk_24yH5wA4KRm7uk2m6DWo37rMSik';
export const SOURCE_KEY = process.env.environment === 'production' ? 'src_1NT295J0sRek2E2S9wmewl1hSjr' : 'src_24yH5vGUPks7O2KRIGUNCHZrR19';

export const MONARCH_SOURCE = '088adec0-65af-49ae-98b3-337ab58d4f6b';
export const MONARCH_TOKEN = 'e9584f8a-2739-486b-a11e-2b176f158cd2';
